import { ICalendarAppBaseText, defaultBaseText } from "../../classes/calendar-text";

/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
interface ICalendarCustomText {
    dateFilterTitleText: string,
    dateAllSelectionText: string,
    accessFilterTitle: string,
    accessAllSelectionText: string
}


let customText: ICalendarCustomText = {
    dateFilterTitleText: "Month",
    dateAllSelectionText: "",
    accessFilterTitle: "Accessibility services",
    accessAllSelectionText:""

}

export type ICalendarAppText = ICalendarCustomText & ICalendarAppBaseText;
export const defaultText: ICalendarAppText = { ...defaultBaseText, ...customText };